import { TenFourText } from '@/components/TenFourText'
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { settingsPageForHref } from '@tenfour/contracts';
import { ChromeIcon } from '@/components/ChromeIcon';
import { useSettingsFieldFocus } from './useSettingsFieldFocus';
import s from './settings-surface.module.css';

export function SettingsSurface({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const focus = useSettingsFieldFocus();
  const page = settingsPageForHref(pathname);
  return (
    <div className={s.surface} {...focus}>
      {page && (
        <header className={s.intro}>
          <Link className={s.back} to="/settings/overview">
            <ChromeIcon name="back" tone="muted" size={16} />
            All settings
          </Link>
          {page.sub && <p><TenFourText>{page.sub}</TenFourText></p>}
        </header>
      )}
      {children}
    </div>
  );
}
